<template>
  <v-container v-if="about" class="py-12 py-md-16 about">
    <!-- Para desktop -->
    <div v-if="!sm" class="d-flex justify-lg-space-between flex-lg-row">
      <div class="justify-center d-flex align-center flex-column about-clip">
        <Title> {{ about.title }}</Title>
        <div class="open-sans darken--text text-start mt-6">
          {{ about.text }}
          <div class="d-flex justify-center">
            <v-btn
              class="white--text py-4 px-6 mt-6 font-weight-bold primary"
              type="submit"
              depressed
              height="38"
              dark
              @click="dialog = true"
            >
              Saiba Mais
            </v-btn>
          </div>
        </div>
      </div>
      <div class="w-50 py-4 about-img">
        <img
          class="d-lg-block d-md-block"
          width="100%"
          :src="files + about.img"
          alt="Cerradus Pneus"
        />
      </div>
    </div>

    <!-- Para mobile -->

    <v-row no-gutters v-else>
      <v-col cols="12">
        <Title> {{ about.title }}</Title>
      </v-col>

      <v-col class="d-flex flex-column align-center mt-10" cols="12">
        <img
          class="d-block"
          width="100%"
          :src="files + about.img"
          alt="Cerradus Pneus"
        />
        <div class="open-sans darken--text text-start mt-6">
          {{ about.text }}
          <div class="d-flex justify-center">
            <v-btn
              class="white--text py-4 px-6 mt-6 font-weight-bold primary"
              type="submit"
              depressed
              height="38"
              dark
              @click="dialog = true"
            >
              Saiba Mais
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Modal saiba mais -->

    <v-dialog v-model="dialog" max-width="900px" width="100%">
      <v-card class="pa-5 relative grey">
        <v-btn
          class="dialog-btn"
          rounded
          color="green darken-1"
          text
          @click="dialog = false"
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <v-card-title>
          <Title> {{ about.title }} </Title>
        </v-card-title>
        <v-card-text
          class="open-sans darken--text"
          v-html="about.text_more"
        ></v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Title from "../../../widgets/Title.vue";
export default {
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    about() {
      return this.$rest(`about`).item;
    },
  },
  components: { Title },
};
</script>

<style>
.before-title {
  filter: invert(1);
  opacity: 0.1;
}
.dialog-btn {
  position: absolute;
  right: 5px;
  top: 5px;
}
.v-btn:not(.v-btn--round).v-size--default {
  padding: 0;
  height: 36px;
  min-width: 36px !important;
}
.about .v-btn {
  border-radius: 0px;
}
@media (max-width: 960px) {
  .about .open-sans {
    font-size: 14px;
  }
}
@media (max-width: 750px) {
  .about-clip {
    padding: 50px 50px 20px 50px !important;
  }
}
.divider {
  width: 100%;
  height: 20px;
  clip-path: polygon(0 0, 100% 0, 97% 100%, 3% 100%);
}
.no-wrap {
  white-space: nowrap;
}
.before-about {
  margin-left: 25px;
  filter: invert(1);
  opacity: 0.08;
  width: 70%;
}
.before-about-mobile {
  margin-left: 18px;
  filter: invert(1);
  opacity: 0.1;
  width: 65%;
}
.w-100 {
  width: 100%;
}
.about-img {
  margin-left: -200px;
  z-index: 0;
}
.w-50 {
  width: 60%;
}
.h-100 {
  height: 100%;
}
.about-clip {
  padding: 50px 150px 20px 50px;
  background-image: url(/img/bg-about.svg?2);
  background-size: contain;
  background-position: top left;
  z-index: 1;
  position: relative;
  width: 70%;
  /* clip-path: polygon(0 0, 100% 0, 92% 100%, 0% 100%); */
}
</style>
